import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { harrisburgConfig } from "./data";

export default function HarrisburgPage() {
  return <CityPageTemplate config={harrisburgConfig} />;
}